export default __webpack_public_path__ + "static/FoundersGrotesk-Semibold-37ef489af34aa0bf163873bd36fa33f1.woff";